import type { ChatHistoryPage, ChatMessageDto } from '@/features/live/types';

/** Pages de 20 côté back, soit 100 messages épinglés chargés à l'entrée. */
export const CHAT_HISTORY_MAX_PAGES = 5;

/** Enchaîne les pages d'historique tant que le back annonce une suite. */
export async function collectChatHistoryPages(
  loadPage: (page: number) => Promise<ChatHistoryPage>,
  maxPages: number = CHAT_HISTORY_MAX_PAGES,
): Promise<ChatMessageDto[]> {
  const collected: ChatMessageDto[] = [];
  const pageLimit = Math.max(1, maxPages);

  for (let page = 0; page < pageLimit; page += 1) {
    const { messages, hasNext } = await loadPage(page);
    collected.push(...messages);
    if (!hasNext || messages.length === 0) break;
  }

  return collected;
}
